import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_RESEARCH_NICHE_ANALYSIS_PAGE: IInventoryPage = {
	'route': '/research/research/niche-analysis',
	'title': 'Niche Analysis',
	'uiReference': [
		'Search a niche or keyword',
		'Scoring details',
		'Niche opportunity score',
		'Market distribution',
		'Marketplace',
		'Product',
		'Niche or keyword',
		'Under Maintenance - Back In A Few Days',
		'Search',
		'Niche Ideas',
		'Explore ideas',
		'Popular niche directions',
		'Select a keyword to analyze it immediately.',
		'Collapse',
		'Niche intelligence',
		'Validate a niche before you design',
		'Turn one keyword into a clear view of demand, competition, seller ranks, keyword opportunities, and the designs already winning the market.',
		'Start an analysis',
		'Find niche ideas',
		'Score potential',
		'Track demand',
		'Compare competitors',
		'Live market signals',
		'Keyword discovery',
		'Analyzing live market data',
		'Building your niche intelligence',
		'Reviewing demand, competition, keywords, seller ranks, and leading designs.',
		'No reliable market data yet',
		'Try a broader niche phrase',
		'We could not find enough seller-rank data for this analysis. Shorten the phrase, change the marketplace, or explore a suggested niche.',
		'Edit search',
		'Browse niche ideas',
		'Total designs',
		'Best sellers',
		'Average top 100 BSR',
		'BSR coverage',
		'Opportunity score',
		'Niche potential',
		'Balanced from competition, demand, seller ranks, reviews, and trend signals.',
		'More data needed',
		'We found results, but not enough to calculate a reliable opportunity score.',
		'Market benchmarks',
		'Performance breakdown',
		'Averages by result group',
		'S+ : You should definitely try this niche',
		'S : Very good',
		'A : Solid',
		'B : Potential',
		'C : Little interest',
		'D : No interest',
		'Loading demand trend',
		'Preparing demand trend',
		'Keyword intelligence',
		'Build a stronger listing vocabulary',
		'Select a keyword to refresh the best-seller designs below.',
		'Search discovery',
		'Related phrases people are exploring',
		'Use cross-platform suggestions to widen or refine the niche.',
		'Competitive landscape',
		'Niche best sellers',
		'/ 3 selected',
		'Loading niche best sellers',
		'Loading leading designs',
		'Select up to three designs to compare their details.',
		'Score',
		'See a focused opportunity score built from demand, competition, trends, reviews, and seller-rank signals.',
		'Discover common listing phrases, long-tail keywords, and related searches that can strengthen your market positioning.',
		'Marketplace context',
		'Compare the niche in supported Amazon marketplaces and products with signals calibrated to the selected market.',
		'Best-seller comparison',
		'Review leading designs and compare up to three competitors to understand patterns, listings, and market positioning.',
		'Keywords',
		'Long-Tail keywords',
		'Demand history time range',
		'Latest observed demand',
		'/ month',
		'Same month last year',
		'n/a',
		'Peak vs prior year',
		'% vs',
		'Usable history',
		'months',
		'observed months · Latest: (/ designs)',
		'Monthly median estimated sales for the currently loaded designs; the shaded range is the middle 50%. Dots are observed months; dashed connectors cross months without enough observations.',
		'Typical demand now',
		'Stronger quarter',
		'Designs with demand',
		'Ranked coverage',
		'/ designs',
		'Current snapshot',
		"Only comparable month(s); showing demand across today's ranked results",
		'No ranked designs in the loaded results',
		'Load more results or adjust the search filters to calculate current demand.',
		'Current ranked designs sorted from strongest to weakest estimated monthly demand. This is a snapshot, not a historical trend.',
		'Sales',
		'Design comparison',
		'Compare historical performance and listing characteristics.',
		'Preparing design comparison',
		'Design',
		'(ASIN: )',
		'Performance',
		'&pound;',
		'&euro;',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.',
		'Remove from favorites',
		'Enter a tag',
		'Favorite tag',
		'Generate image using AI',
		'NEW',
		'History Rank :',
		'History Price : NA',
		'Removed',
		'ASIN',
		'review(s)',
		'Published since',
		'Saved',
		'Update tag'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/niche-analysis/niche-analysis.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/niche-analysis/niche-analysis.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/niche-analysis/niche-analysis.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/keyword/shared/components/preview/word-frequency-keyword/word-frequency-keyword.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/bsr-seller-rank/bsr-seller-rank.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/bsr-seller-rank/bsr-seller-rank.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/bsr-seller-rank/bsr-seller-rank.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/charts/distributions/distributions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/statistics/charts/distributions/distributions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/suggestions/suggestions.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/suggestions/suggestions.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/design-carousel/design-carousel.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/compare-designs/compare-designs.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/compare-designs/compare-designs.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/design-mba/design-mba.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/designs/mba/trends-badge/trends-badge.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/shared/components/page-plugins/add-to-favorite/add-to-favorite.component.html'
	],
	'aliases': []
};
